import {
  // Box,
  ChevronUp,
  Edit,
  // Eye,
  Filter,
  GitMerge,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import useProducts from "../../controllers/useProducts";
import usePermissions from "../../core/hooks/usePermissions";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Brand from "../../core/modals/inventory/brand";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { all_routes } from "../../Router/all_routes";
import { currencyFormatter, dateFormatter } from "../../utils/helperFunctions";

const ProductList = () => {
  const { canAdd, canEdit, canDelete } = usePermissions();

  const {
    values: {
      data,
      total,
      loading,
      search,
      sort,
      pageValues,
      brandList,
      categoryList,
      subCategoryList,
      selectedBrand,
      selectedCategory,
      selectedSubCategory
    },
    states: { setSelectedBrand, setSelectedCategory, setSelectedSubCategory },
    functions: { onChange, onChangeSort, handlePageChange, onDelete },
  } = useProducts();

  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const toggle = useSelector((state) => state.toggle_header);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const route = all_routes;
  const options = [
    { value: "name", label: "Sort By Name" },
    { value: "price", label: "Sort By Price" },
  ];
  // const productlist = [
  //   { value: "choose", label: "Choose Product" },
  //   { value: "lenovo", label: "Lenovo 3rd Generation" },
  //   { value: "nike", label: "Nike Jordan" },
  // ];
  // const categorylist = [
  //   { value: "choose", label: "Choose Category" },
  //   { value: "laptop", label: "Laptop" },
  //   { value: "shoe", label: "Shoe" },
  // ];
  // const subcategorylist = [
  //   { value: "choose", label: "Choose Sub Category" },
  //   { value: "computers", label: "Computers" },
  //   { value: "fruits", label: "Fruits" },
  // ];
  // const brandlist = [
  //   { value: "all", label: "All Brand" },
  //   { value: "lenovo", label: "Lenovo" },
  //   { value: "nike", label: "Nike" },
  // ];
  // const price = [
  //   { value: "price", label: "Price" },
  //   { value: "12500", label: "$12,500.00" },
  //   { value: "13000", label: "$13,000.00" },
  // ];

  const columns = [
    {
      title: "Product",
      dataIndex: "name",
      render: (text, record) => {
        console.log("TEXT", text);
        console.log("record", record);
        return (
          <span className="productimgname">
            <Link className="product-img stock-img">
              <ImageWithBasePath
                alt=""
                src={
                  record.images?.length > 0
                    ? record.images[0]
                    : "assets/img/product/noimage.png"
                }
                isApiImage={record.images?.length > 0 ? true : false}
              />
            </Link>
            <Link>{text}</Link>
          </span>
        );
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
    },
    {
      title: "Brand",
      dataIndex: "brand",
      render: (text, record) => record.brand.name, // Accessing role.name from the record
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text, record) => record.category.name, // Accessing role.name from the record
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (total_amount) => currencyFormatter(total_amount),
    },
    // {
    //   title: "Variation",
    //   dataIndex: "has_variations",
    //   sorter: (a, b) => a.has_variations.length - b.has_variations.length,
    // },
    // {
    //   title: "Qty",
    //   dataIndex: "quantity",
    //   sorter: (a, b) => a.quantity.length - b.quantity.length,
    // },

    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => dateFormatter(text),
    },

    ...(canEdit || canDelete
      ? [
          {
            title: "Action",
            dataIndex: "action",
            render: (text, record) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  <div className="input-block add-lists"></div>
                  {canEdit && (
                    <Link
                      to={route.editproduct}
                      state={{ id: record.id }}
                      onClick={() => {
                        console.log("record", record, record.id);
                        setSelectedRow(record);
                      }}
                      className="me-2 p-2"
                    >
                      <Edit className="feather-edit" />
                    </Link>
                  )}

                  {canDelete && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => onDelete(record.id)}
                    >
                      <Trash2 className="feather-trash-2" />
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : []),
  ];

  console.log("selectedRow", selectedRow);
  // const renderTooltip = (props) => (
  //   <Tooltip id="pdf-tooltip" {...props}>
  //     Pdf
  //   </Tooltip>
  // );
  // const renderExcelTooltip = (props) => (
  //   <Tooltip id="excel-tooltip" {...props}>
  //     Excel
  //   </Tooltip>
  // );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  console.log("sortsortsort", sort);
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Product List</h4>
              <h6>Manage your products</h6>
            </div>
          </div>
          <ul className="table-top-head">
            {/* <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li> */}
            {/* <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li> */}
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={toggle ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!toggle));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          {canAdd && (
            <div className="page-btn">
              <Link to={route.addproduct} className="btn btn-added">
                <PlusCircle className="me-2 iconsize" />
                Add New Product
              </Link>
            </div>
          )}

          {/* <div className="page-btn import">
            <Link
              to="#"
              className="btn btn-added color"
              data-bs-toggle="modal"
              data-bs-target="#view-notes"
            >
              <Download className="me-2" />
              Import Product
            </Link>
          </div> */}
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => onChange(e.target.value)}
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort">
                <Sliders className="info-img" />
                <Select
                  value={sort}
                  className="img-select"
                  classNamePrefix="react-select"
                  placeholder="Sort By"
                  options={options}
                  onChange={(selected) => {
                    onChangeSort(selected);
                  }}
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="row">
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <StopCircle className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={brandList}
                            value={selectedBrand}
                            onChange={setSelectedBrand}
                            placeholder="Select Brand"
                            isClearable
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-2 col-sm-6 col-12"> */}
                      {/* <div className="input-blocks">
                          <Box className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={productlist}
                            placeholder="Choose Product"
                          />
                        </div> */}
                      {/* </div> */}
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <StopCircle className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={categoryList}
                            placeholder="Choose Category"
                            value={selectedCategory}
                            onChange={setSelectedCategory}
                            isClearable
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="input-blocks">
                          <GitMerge className="info-img" />
                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={subCategoryList}
                            placeholder="Choose Sub Category"
                            value={selectedSubCategory}
                            onChange={setSelectedSubCategory}
                            isClearable
                          />
                        </div>
                      </div>

                      <div className="col-lg-2 col-sm-6 col-12">
                        {/* <div className="input-blocks">
                          <i className="fas fa-money-bill info-img" />

                          <Select
                            className="img-select"
                            classNamePrefix="react-select"
                            options={price}
                            placeholder="Price"
                          />
                        </div> */}
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12"></div>
                      <div className="col-lg-2 col-sm-6 col-12">
                        {/* <div className="input-blocks">
                          <Link className="btn btn-filters ms-auto">
                            {" "}
                            <i
                              data-feather="search"
                              className="feather-search"
                            />{" "}
                            Search{" "}
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table
                total={total}
                loading={loading}
                columns={columns}
                onPageChange={handlePageChange}
                dataSource={data?.data || []}
                pagination={pageValues}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default ProductList;
